import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_DRIVER_SEARCH_COLUMNS } from "./consts";
import { VehicleDriverSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const VehicleDriverSearchResults: React.FC<VehicleDriverSearchResultsProps> = (
  props
) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onVehicleClick,
    onDeleteClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_DRIVER_SEARCH_COLUMNS(
          t,
          onVehicleClick,
          onDeleteClick
        )}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(VehicleDriverSearchResults);
